<template>
  <div id="app">
    <h3 class="title has-text-centered">NEWS GERAKAN PANDAI</h3>
      <section>
        <div class="rows">
          <div class="row">
            <div class="columns">
              <div class="column" style="margin:2%">
                <b-field
                label="Bulan">
                <b-select placeholder="Select a month" expanded  v-model="month" @input="getDataSorting()">
                    <option v-for="item in bulan" :key="item.id" 
                    :value="item.id" >
                    {{item.name}}
                    </option>
                </b-select>
              </b-field>
              </div>
              <div class="column" style="margin:2%">
                <b-field
                  label="Tahun">
                  <b-select placeholder="Select a year" expanded v-model="year" @input="getDataSorting()">
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                  </b-select>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="columns is-multiline" style="margin-left:2%;margin-right:2%">
          <div class="column is-one-third" v-for="news in paginatedItemsNews" :key="news.id">
            <b-carousel :autoplay="false" :interval="8000">
                  <b-carousel-item v-if="news.picture !== null">
                  <figure class="image is-3by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture)" alt="Product photos">
                  </figure>
                  </b-carousel-item>

                  <b-carousel-item v-if="news.picture1 !== null">
                  <figure class="image is-3by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture1)" alt="Product photos">
                  </figure>
                  </b-carousel-item>

                  <b-carousel-item v-if="news.picture2 !== null">
                  <figure class="image is-3by3">
                      <img style="object-position: center; object-fit: contain"  :src="getPicture(news.picture2)" alt="Product photos">
                  </figure>
                  </b-carousel-item>

                  <b-carousel-item v-if="news.url !=null">
                  <figure class="image is-3by3">
                      <iframe class="has-ratio" width="640" height="360" 
                      :src="news.url" frameborder="0" allowfullscreen></iframe>
                  </figure>
                  </b-carousel-item>
              </b-carousel> 
              <h1 class="image animate__animated animate__backInUp has-text-centered;" style="font-size:18px"><b>{{news.title}}</b></h1>
              Uploaded:
              <b-icon
                  icon="timer"
                  size="is-small">
              </b-icon>
                  {{new Date(news.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
              <br>
              <b-button icon-right="arrow-right-bold" type="is-primary is-light" 
                  outlined style="font-weight:bold;margin-left:5px" size="is-small"
                  tag="router-link"
                  :to="'/news/' + news.id_news"
                  target="_blank">READ MORE
              </b-button>
          </div>
        </div>
          <b-pagination
            :total="totalNews"
            :current.sync="currentNews"
            range-before="2"
            range-after="2"
            order="is-centered"
            rounded
            :per-page="perPageNews"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
        </b-pagination>
      </section>
  </div>
</template>

<script>

export default {
        data() {
            return {
              carousel:true,
              isLoading: false,
              
              news:[],
               bulan : 
              [
                  {id: 1, name:'Januari'},
                  {id: 2, name:'Febuari'},
                  {id: 3, name:'Maret'},
                  {id: 4, name:'April'},
                  {id: 5, name:'Mei'},
                  {id: 6, name:'Juni'},
                  {id: 7, name:'Juli'},
                  {id: 8, name:'Agustus'},
                  {id: 9, name:'September'},
                  {id: 10, name:'Oktober'},
                  {id: 11, name:'November'},
                  {id: 12, name:'Desember'},

              ],
              config: {},
              month: new Date().getMonth() + 1,
              year: new Date().getFullYear(),

              currentNews: 1,
              perPageNews: 6,

            }
        },
    methods: {

    getDataSorting()
    {
      var uri = this.$apiUrl + 'sorting/news/' + this.month + '/' + this.year 

      this.$http.get(uri).then(response =>
      {
        this.news = response.data.value
      })
     
    },


    getPicture(picture){
      var uri = this.$apiUrl + 'news/picture/' + picture
        
      return uri;
    },
 
    },
    computed: {
      totalNews(){
       return this.news.length
      },
      paginatedItemsNews(){
        let page_number = this.currentNews-1
        return this.news.slice(page_number * this.perPageNews, (page_number + 1) * this.perPageNews);
      },
    },
    mounted()
    {
      this.getDataSorting()
    }
}
</script>
